import window from 'window';
import moment from 'moment';

import { registerFcmSubscription } from '../../fcm-api';

export const getTimeZone = () => moment.tz.guess();

export const getFirebaseConfig = () => {
	return {
		apiKey: "AIzaSyAqBsqyLbBqGINSDXgyj-5-CiWDCeXkUcA",
		projectId: "rgs-dms",
		messagingSenderId: "959687628539",
		appId: "1:959687628539:web:6c2140cb3f6dc44c04825e",
	};
};

export const addFirebaseScripts = () => {
	if (!window.firebase) {
		const appScript = window.document.createElement("script");
		appScript.async = false;
		appScript.src = "https://www.gstatic.com/firebasejs/10.6.0/firebase-app-compat.js";
		const target = window.document.documentElement.firstChild;
		target.appendChild(appScript);

		const messageScript = window.document.createElement("script");
		messageScript.async = false;
		messageScript.src
			= "https://www.gstatic.com/firebasejs/10.6.0/firebase-messaging-compat.js";
		target.appendChild(messageScript);
	}
};

export const checkFcmAvailability = () => {
	const swSupported = ('serviceWorker' in window.navigator);
	const notificationSupported = ('Notification' in window);
	const pushesSupported = ('PushManager' in window);
	const fcmSupported = window.firebase.messaging.isSupported();

	return (swSupported && notificationSupported && pushesSupported && fcmSupported);
};

export const getPushSubResult = async () => {
	try {
		await window.navigator.serviceWorker.register('firebase-messaging-sw.js');
		await window.navigator.serviceWorker.ready;

		const firebaseConfig = getFirebaseConfig();

		if (window.firebase.apps.length === 0) {
			window.firebase.initializeApp(firebaseConfig);
		}

		const messaging = window.firebase.messaging();

		const token = await messaging.getToken();

		const timeZoneString = getTimeZone();
		const fcmSubData = {
			DeviceID: token,
			TimeZone: timeZoneString,
		};

		const subscriptionResult = await registerFcmSubscription(fcmSubData);

		return subscriptionResult;
	} catch (error) {
		error.handled = true;
		throw error;
	}
};

export const handlePushes = async () => {
	try {
		await window.navigator.serviceWorker.register('firebase-messaging-sw.js');
		await window.navigator.serviceWorker.ready;

		const firebaseConfig = getFirebaseConfig();

		if (window.firebase.apps.length === 0) {
			window.firebase.initializeApp(firebaseConfig);
		}

		const messaging = window.firebase.messaging();
		messaging.onMessage((payload) => {
			console.log('Message received:', payload);
			// ...
		});
	} catch (error) {
		error.handled = true;
		throw error;
	}
};
